"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var popMessage_1 = require("../popMessage");
var button_1 = require("../button");
var input_1 = require("../../../lib/components/input");
var ConfirmPopMessage = /** @class */ (function (_super) {
    tslib_1.__extends(ConfirmPopMessage, _super);
    function ConfirmPopMessage(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onConfirmActionValueChange = function (e) {
            var confirmActionText = _this.props.confirmActionText;
            var isConfirmActionMatch = _this.state.isConfirmActionMatch;
            var value = e.target.value;
            _this.setState({ confirmActionValue: value });
            if ((!isConfirmActionMatch && confirmActionText === value) || (isConfirmActionMatch && confirmActionText !== value)) {
                _this.setState({ isConfirmActionMatch: !isConfirmActionMatch });
            }
        };
        _this.state = { confirmActionValue: "", isConfirmActionMatch: false };
        return _this;
    }
    ConfirmPopMessage.prototype.render = function () {
        var _a = this.props, theme = _a.theme, className = _a.className, cancelText = _a.cancelText, onCancelClick = _a.onCancelClick, confirmText = _a.confirmText, onConfirmClick = _a.onConfirmClick, title = _a.title, text = _a.text, confirmActionText = _a.confirmActionText, others = tslib_1.__rest(_a, ["theme", "className", "cancelText", "onCancelClick", "confirmText", "onConfirmClick", "title", "text", "confirmActionText"]);
        var _b = this.props, red = _b.red, green = _b.green, yellow = _b.yellow;
        var classes = classnames_1.default(theme.message, className);
        var _c = this.state, isConfirmActionMatch = _c.isConfirmActionMatch, confirmActionValue = _c.confirmActionValue;
        var showCancel = !!onCancelClick;
        var showConfirm = !!onConfirmClick;
        return (React.createElement(popMessage_1.PopMessage, tslib_1.__assign({}, others, { className: classes }),
            React.createElement("div", { className: theme.inner },
                title ? React.createElement("div", { className: theme.title }, title) : null,
                text ? React.createElement("div", { className: theme.text }, text) : null,
                confirmActionText ?
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: theme.text, style: { marginTop: "1rem" } },
                            "To confirm this action, type ",
                            React.createElement("em", null,
                                React.createElement("b", null, confirmActionText)),
                            " in the text input field."),
                        React.createElement(input_1.Input, { value: confirmActionValue, onChange: this.onConfirmActionValueChange, placeholder: confirmActionText }))
                    : null,
                React.createElement("div", { className: theme.actions },
                    showCancel ? React.createElement(button_1.Button, { small: true, gray: true, className: theme.cancel, onClick: onCancelClick }, cancelText) : null,
                    showConfirm ? React.createElement(button_1.Button, tslib_1.__assign({ small: true, blue: true, className: theme.confirm, disabled: confirmActionText ? !isConfirmActionMatch : false, onClick: onConfirmClick }, { red: red, green: green, yellow: yellow }), confirmText) : null))));
    };
    ConfirmPopMessage.defaultProps = {
        cancelText: "Cancel",
        confirmText: "Confirm"
    };
    return ConfirmPopMessage;
}(React.Component));
exports.default = ConfirmPopMessage;
